var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[_c('Header'),_c('SearchBar',{ref:"searchBar",on:{"searchClick":_vm.onSearchclick}}),_c('div',{staticClass:"layout-content"},[_c('div',{staticClass:"container"},[_c('router-view',{attrs:{"searchQuery":_vm.searchQuery}})],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }